import { Card, Section } from "@bafe/ui";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router";

import { QueryState } from "../../components/QueryState";
import { api } from "../../lib/api";
import { queryKeys } from "../../lib/query";

const NOTICES = [
	{
		id: "service",
		label: "Service notices",
		detail: "Outages, planned maintenance and anything that affects mail delivery.",
		audience: "Owners and administrators",
	},
	{
		id: "domain",
		label: "Domain and DNS",
		detail: "When a domain is verified, when a record changes, and when something needs your attention.",
		audience: "Owners and administrators",
	},
	{
		id: "storage",
		label: "Storage",
		detail: "When your account passes 80 percent of its storage, and again when it is nearly full.",
		audience: "Owners and administrators",
	},
	{
		id: "migration",
		label: "Migration",
		detail: "When a migration finishes, and if it could not copy everything.",
		audience: "The person who started it",
	},
	{
		id: "billing",
		label: "Billing",
		detail: "Invoices, renewals and failed payments.",
		audience: "The billing email address",
	},
	{
		id: "security",
		label: "Security",
		detail: "Password changes, two-factor changes and new sign-ins we do not recognise.",
		audience: "The account holder",
	},
];

export function NotificationsSection() {
	const organisation = useQuery({
		queryKey: queryKeys.organisation,
		queryFn: () => api.getOrganisation(),
	});

	return (
		<Section
			title="Notifications"
			description="Key only emails you about things that affect your service. There are no marketing emails."
		>
			<Card flush>
				<ul>
					{NOTICES.map((notice) => (
						<li
							key={notice.id}
							className="flex flex-wrap items-start justify-between gap-3 border-b border-(--border-subtle) px-4 py-3.5 last:border-0"
						>
							<div className="flex max-w-prose flex-col gap-0.5">
								<p className="text-sm font-medium text-(--text-primary)">{notice.label}</p>
								<p className="text-sm text-(--text-secondary)">{notice.detail}</p>
							</div>
							<p className="text-xs text-(--text-muted)">{notice.audience}</p>
						</li>
					))}
				</ul>
			</Card>

			<QueryState query={organisation} errorTitle="We could not load your billing email address.">
				{(data) => (
					<p className="max-w-prose text-sm text-(--text-secondary)">
						Billing notices currently go to{" "}
						<span className="text-(--text-primary)">{data.billingEmail}</span>. Change it under{" "}
						<Link to="/manage/config" className="underline underline-offset-2">
							Organisation
						</Link>
						.
					</p>
				)}
			</QueryState>
		</Section>
	);
}
